import { http } from '@/utils/http';

// 投票列表页
export const getlist = (
  voteName: string,
  page?: number,
  type?: string | number,
  data?: any,
) => {
  if (data) {
    return http.get(
      '/vote/' +
        voteName +
        '/controller.php?enews=vote-list&type= ' +
        type +
        '&page=' +
        page +
        '&search=' +
        data,
    );
  } else {
    return http.get(
      '/vote/' +
        voteName +
        '/controller.php?enews=vote-list&type= ' +
        type +
        '&page=' +
        page,
    );
  }
};

// 投票列表页
export const detail = (voteName: string, id?: string | number) => {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=detail&id= ' + id,
  );
};

// 投票列表页
export const rules = (voteName: string) => {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=rules',
  );
};
